import { render, staticRenderFns } from "./NewEdit.vue?vue&type=template&id=3630a2a4"
import script from "./NewEdit.vue?vue&type=script&lang=js"
export * from "./NewEdit.vue?vue&type=script&lang=js"
import style0 from "./NewEdit.vue?vue&type=style&index=0&id=3630a2a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports